import React from 'react';
export default (
  <svg width="14px" height="12px" viewBox="0 0 14 12">
    <defs>
      <path
        d="M50.6296173,16.7902486 L59.8345774,16.7902486 L55.8130729,20.6466895 C55.4916822,20.9548887 55.4916822,21.4606514 55.8130729,21.7688506 C56.1344636,22.0770498 56.6536333,22.0770498 56.975024,21.7688506 L62.4057032,16.5610749 C62.727094,16.2528757 62.727094,15.7550155 62.4057032,15.4468163 L56.9832648,10.231138 C56.8293009,10.0831608 56.6202726,10 56.4022892,10 C56.1843059,10 55.9752776,10.0831608 55.8213137,10.231138 C55.4999229,10.5393372 55.4999229,11.0371974 55.8213137,11.3453965 L59.8345774,15.20974 L50.6296173,15.20974 C50.1763739,15.20974 49.8055385,15.5653545 49.8055385,16 C49.8055385,16.4346342 50.1763739,16.7902486 50.6296173,16.7902486 Z"
        id="arrowPrew_svg__a"
      />
    </defs>
    <use
      xlinkHref="#arrowPrew_svg__a"
      transform="translate(-49.33 -10)"
      fillRule="evenodd"
    />
  </svg>
);
